import { FunctionComponent } from "react";
import { Button } from "@ui-kit/Button/Button";
import { useTranslation } from "react-i18next";
import "./ModalNavFooter.css";
interface ModalNavFooterProps {
  onBack?: () => void;
  onNext?: () => void;
  backText?: string;
  nextText?: string;
  backDisabled?: boolean;
  nextDisabled?: boolean;
  canGoBack?: boolean;
  canGoNext?: boolean;
}

const ModalNavFooter: FunctionComponent<ModalNavFooterProps> = ({
  onBack,
  onNext,
  backText,
  nextText,
  backDisabled = false,
  nextDisabled = false,
  canGoBack = true,
  canGoNext = true,
}) => {
  const { t } = useTranslation();

  return (
    <div className="modal-nav-footer">
      {canGoBack ? (
        <Button type="text" onPress={onBack} disabled={backDisabled}>
          {backText || t("common.back")}
        </Button>
      ) : (
        // Hidden div to take up space for correct flex layout
        <div className="modal-nav-placeholder" />
      )}
      {canGoNext ? (
        <Button type="primary" onPress={onNext} disabled={nextDisabled}>
          {nextText || t("common.next")}
        </Button>
      ) : (
        // Hidden div to take up space for correct flex layout
        <div className="modal-nav-placeholder" />
      )}
    </div>
  );
};

export { ModalNavFooter, ModalNavFooterProps };
